import { PRODUCT_CATEGORIES } from './productCategories';

export const AIR = {
  id: 1,
  name: 'AIR',
  productCategoryType: PRODUCT_CATEGORIES.MAIN,
} as const;
